import axios from 'axios'
import store from '@/store'
import storage from './storage'
import wx from 'weixin-js-sdk'

axios.defaults.timeout = 50000
axios.defaults.baseURL = ''
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded;charset=UTF-8'

/**
 * 请求方法
 */
export function fetch(method, url, params, type = 'orthers') {
  let headers = {
    platform: 'SaasMobile',
    'Content-Type': 'application/json',
    'Access-channel': 'saas_xcx'
  }
  if (type == 'login') {
    headers.Authorization = 'Basic c2Fhc01vYmlsZTpxMTIzNDU2'
  } else if (type == 'orthers') {
    Object.assign(headers, {
      Authorization: 'Bearer ' + storage.get('access_token'),
      companyId: storage.get('companyId') ? storage.get('companyId') : ''
    })
  }
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: url,
      headers: headers,
      data: params,
      params: params
    })
      .then(response => {
        // console.log("response === "  + JSON.stringify(response))
        if (response.status == 200 ) {
          if (type == 'login') {
            if (response.data.access_token) {
              resolve(response.data)
            } else
              store.state.toast = {
                show: true,
                title: '登录失败',
                icon: 'none'
              }
          } else {
            const data = response.data
            switch (parseInt(data.code)) {
              case 1000:
                resolve(data)
                break
              case 2000:
              case 3000:
                store.state.toast = {
                  show: true,
                  title: '请重新登录',
                  icon: 'none'
                }
                if (store.state.sence == 1) {
                  wx.miniProgram.reLaunch({
                    url: '/pages/login/login'
                  })
                }
                break
              case 4000:
                store.state.toast = {
                  show: true,
                  title: '暂无操作权限，请联系管理员',
                  icon: 'none'
                }
                break
              case 4100:
              case 5000:
                store.state.toast = {
                  show: true,
                  title: data.msg,
                  icon: 'none'
                }
                break
              case 5100:
                store.state.toast = {
                  show: true,
                  title: '请勿重复提交',
                  icon: 'none'
                }
                break
              case 6000:
                store.state.toast = {
                  show: true,
                  title: '程序异常，请联系管理员',
                  icon: 'none'
                }
                break
              case 6100:
                store.state.toast = {
                  show: true,
                  title: '您的账号已过期，请联系管理员',
                  icon: 'none'
                }
                break
              default:
                store.state.toast = {
                  show: true,
                  title: '请检查返回code是否符合规范',
                  icon: 'none'
                }
            }
          }
        }
      })
      .catch(err => {
        store.state.toast = {
          show: true,
          title: err,
          icon: 'none'
        }
        reject(err)
      })
  })
}
